<div class="page-outer-wrapper">
  <div class="page-header">
    <div class="hamburger">
      <a routerLink="/overwatch"><img src="/assets/images/apple-touch-icon-72x72-precomposed.png" height="28" width="28"></a>
    </div>
    <div id="nav-bar" class="nav-bar">
    </div>
  </div>
  <div class="page-content-background">
    <div class="page-content">

      <div style="margin: 12px;">

        <h1>Profile</h1>

        <div style="margin-top: 24px;">
          <span [innerHTML]="profilePic"></span>
          <span style="margin-left: 12px;">{{user.firstName}} {{user.lastName}} [{{user.options.type}}]</span>
        </div>

        <table style="margin-top: 24px;" cellspacing="0" cellpading="0">
          <tr><td style="text-align: right; width: 120px;">UserID:</td><td>{{user.username}}</td></tr>
          <tr><td style="text-align: right; width: 120px;">Email:</td><td>{{user.email}}</td></tr>
          <tr><td style="text-align: right; width: 120px;">First Name:</td><td>{{user.firstName}}</td></tr>
          <tr><td style="text-align: right; width: 120px;">Last Name:</td><td>{{user.lastName}}</td></tr>
        </table>

      </div>

    </div>
    <div id="pano-footer" class="pano-footer"></div>
  </div>
</div>
